@if (!hasClicked) {
    <span
        ngbTooltip='Click the "..." to expand the field.'
        class="pointer"
        (click)="hasClicked = true"
    >
        {{ lessData }}...
    </span>
}
@if (hasClicked) {
    <span>
        {{ data }}
    </span>
}
